'use strict';
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/notifications/node_modules/core-js/internals/validate-arguments-length.js
// module id = 5791
// module chunks = 25